import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { ILogInAsFormValues } from './LogInAsForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type ILogInAsFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<ILogInAsFormValues>;
};

export const LogInAsFormMainSection: React.FC<ILogInAsFormMainSectionProps> = (
  props,
) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled label={t('common.emailAddress')} required>
        <FormField
          name="emailAddress"
          control={form.control}
          as={TextInputField}
          type="email"
          forwardError
        />
      </Labeled>
    </FormSection>
  );
};
